import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteYear,
  getYearById,
  postYear,
  updateYear,
} from "../../../../api/year";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyYear() {
  return {
    year: "",
    matricula: "",
  };
}

export default function EditYearsPage() {
  const [year, setYear] = useState(getEmptyYear());
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const yearId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!yearId) {
      disableLoadingData();
      return;
    }
    getYearById(yearId)
      .then((res) => {
        if (res.status === 200) {
          setYear(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get year." });
        history.push("/years");
      });
  }, [yearId, disableLoadingData, history]);

  function saveYear() {
    if (!yearId) {
      postYear(year)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Year successfully created.",
            });
            history.push("/years");
          }
        })
        .catch((error) => {
          alertError({ error: error, customMessage: "Could not save year." });
        });
    } else {
      updateYear(yearId, year)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            history.push("/years");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    let value = event.target.value;
    if (element === "matricula") value = value.trim().replaceAll(" ", "");
    setYear({ ...year, [element]: value });
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Edit year"></CardHeader>
          <CardBody>
            <TextField
              id={`year`}
              label="Año"
              value={year.year}
              onChange={handleChange("year")}
              InputLabelProps={{
                shrink: true,
              }}
              type="number"
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`matricula`}
              label="Matrícula"
              value={year.matricula}
              onChange={handleChange("matricula")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
          </CardBody>
        </Card>
        <Button
          onClick={() => history.push("/years")}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Back
        </Button>
        <Button
          onClick={() => saveYear()}
          variant="outlined"
          color="primary"
          style={{ marginRight: "20px" }}
        >
          Save year
        </Button>
        {yearId && year.matricula !== "es" && (
          <>
            <MuiThemeProvider theme={theme}>
              <Button
                onClick={() => setOpenConfirmDialog(true)}
                variant="outlined"
                color="secondary"
              >
                Delete year
              </Button>
            </MuiThemeProvider>

            <ConfirmDialog
              title={"Are you sure you want to delete this year?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteYear(yearId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Year deleted successfully",
                      });
                      history.push("/years");
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not delete economic sector.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
